import axios from 'axios'
import NProgress from 'nprogress'
import moment from 'moment'
import { refreshToken } from 'services/authApis'
import config from '../config'
import { getToken, logout } from './index'

axios.defaults.baseURL = config.baseUrl

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

const errorHandler = error => {
  if (error.response && error.response.status === 401) {
    logout()
    window.location.href = '/'
    return false
  }
  return {
    errors: error.response || 'something went wrong',
  }
}

const request = async (
  uri,
  { method = 'GET', data, params, progress = true, setLoading, headers = {} } = {},
) => {
  if (progress) NProgress.start()
  if (setLoading) setLoading(true)

  const expiresIn = localStorage.getItem('expiresIn')
  if (
    expiresIn &&
    moment()
      .add(expiresIn, 'seconds')
      .isBefore(moment())
  ) {
    const res = await refreshToken()
    localStorage.setItem('token', res.data.result.access_token)
    localStorage.setItem('expiresIn', res.data.result.expires_in)
    await sleep(1000)
  }

  const res = axios({
    method,
    url: uri,
    data,
    params,
    headers: {
      'Content-Type': 'application/json',
      ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
      ...headers,
    },
  })
    .then(response => response)
    .catch(errorHandler)
    .finally(() => {
      if (progress) NProgress.done()
      if (setLoading) setLoading(false)
    })

  return res
}

export default request
